import axios from "axios";

const client = axios.create({ baseURL: "" });

// Inject Bearer token on every request if present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("gs_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Auth endpoints ───────────────────────────────────────────────────────────
export const requestOtp = (email) =>
  client.post("/api/v1/auth/request-otp", { email });

export const verifyOtp = (email, otp) =>
  client.post("/api/v1/auth/verify-otp", { email, otp });

// ── Account ───────────────────────────────────────────────────────────────────
export const getAccountMe = () =>
  client.get("/api/v1/account/me");

export const updateProfile = (payload) =>
  client.patch("/api/v1/account/profile", payload);

// ── Access / license ─────────────────────────────────────────────────────────
export const validateAccessCode = (code, email, gstin) =>
  client.post("/api/v1/access/validate-code", { code, email, gstin });

export const getLicenseStatus = () =>
  client.get("/api/v1/license/status");

// ── Upload ───────────────────────────────────────────────────────────────────
export const uploadSalesFile = (file, accessCode, email, gstin, signal) => {
  const form = new FormData();
  form.append("file", file);
  const params = new URLSearchParams({ access_code: accessCode });
  if (email) params.append("email", email);
  if (gstin) params.append("gstin", gstin);
  return client.post(`/api/v1/upload/sales?${params}`, form, { signal });
};

// ── Certificates ─────────────────────────────────────────────────────────────
export const issueCertificate = (scoreRunId) =>
  client.post("/api/v1/certificates/issue", { score_run_id: scoreRunId });

export const verifyCertificate = (certId) =>
  client.get(`/api/v1/certificates/${certId}/verify`);

export const revokeCertificate = (certId, reason) =>
  client.post(`/api/v1/certificates/${certId}/revoke`, { reason });

export const downloadCertificatePdf = (certId) =>
  client.get(`/api/v1/certificates/${certId}/pdf`, { responseType: "blob" });

// ── Payments ─────────────────────────────────────────────────────────────────
export const getPaymentConfig = () =>
  client.get("/api/v1/payments/config");

export const startFreeTrial = () =>
  client.post("/api/v1/payments/start-trial", {});

export const createOrder = (plan) =>
  client.post("/api/v1/payments/create-order", { plan });

export const verifyPayment = (payload) =>
  client.post("/api/v1/payments/verify", payload);

// ── Waitlist ──────────────────────────────────────────────────────────────────
export const joinAutofetchWaitlist = (email, gstin) =>
  client.post("/api/v1/waitlist/autofetch", { email, gstin: gstin || undefined });

// ── Admin ────────────────────────────────────────────────────────────────────
export const adminGenerateCode = (payload) =>
  client.post("/api/v1/admin/license/generate", payload);

export const adminListUsers = (params) =>
  client.get("/api/v1/admin/users", { params });

export const adminUserActivity = (accountId) =>
  client.get(`/api/v1/admin/users/${accountId}/activity`);

export const adminListWaitlist = (params) =>
  client.get("/api/v1/admin/waitlist", { params });

export default client;
